var $ = require('jQuery');
var Slider = require('bootstrap-slider');
var isTouchDevice = require('./is-touch-device.js');

/**
 * Slider.
 *
 * Usage:
 *   var slider = new Slider();
 *   slider.setup(selector);
 *
 */
module.exports = function() {
    let sliders = [];

    /**
     * @param {String} selector
     * @return {Array}
     */
    this.setup = (selector) => {
        $(selector).each((i, element) => {
            const label = $(element).data('slider-label');
            const isLocked = $(element).hasClass('locked-score');

            const slider = new Slider(element, {
                tooltip: isTouchDevice() ? 'always' : 'show',
                formatter: value => label + ' ' + value
            });

            sliders.push(slider);
        });

        return sliders;
    };
};
